import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core'
import { Observable, of } from 'rxjs'
import { TabTyypit } from 'app/kirjanpito/kirjanpito.component'

@Component({
  selector: 'app-kirjanpito-tilintarkastus-lahetykset',
  templateUrl: './tilintarkastus-kirjanpito-lahetykset.component.html',
  styleUrls: ['./tilintarkastus-kirjanpito-lahetykset.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjanpitoTilintarkastusLahetyksetComponent implements OnInit, OnDestroy {
  @Input() yhdistettyStatusObservable: Observable<'yes' | 'no' | 'not-saved-yet'>
  @Input() valittuTabObservable: Observable<TabTyypit>
  @Input() veroilmoitusLahetettyObservable: Observable<boolean>
  @Input() naytaIlmoitusValilehtiObservable: Observable<boolean>
  @Input() naytaVeroilmoitusValilehtiObservable: Observable<boolean>
  @Input() naytaLahetysValilehtiObservable: Observable<boolean> = of(false)
  @Input() onkoSpostejaLahetetty: boolean

  @Output() vaihdaAlvIlmoitukseen = new EventEmitter()
  @Output() vaihdaVeroilmoitukseen = new EventEmitter()
  @Output() vaihdaLahetaNakymaan = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {}
}
